import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import PrivacyPolicy from '../components/Privacyandterms/Privacypolicy'

const Privacypage = () => {
  return (
    <div>
        <Navbar/>
        <PrivacyPolicy/>
        <Footer/>
        

    </div>
  )
}

export default Privacypage
